





























































































































import Vue from 'vue'
import Component from 'vue-class-component'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import Icon from '@/components/Icon.vue'
import {
  EAutoPaySettingStatus,
  EAutoPayType,
  EPaymentMethodType,
  EUserPermissions,
  IResidentAutoPaySettingFilters
} from '@zunta/configurations'
import { PaymentsModule } from '@/store/modules/payments.module'
import { getModule } from 'vuex-module-decorators'
import Confirm from '@/components/Confirm.vue'
import Card from '@/components/Card.vue'
import Table from '@/components/tables/Table.vue'
import TableSubRow from '@/components/tables/TableSubRow.vue'
import ResidentAutopaymentSubrow
  from '@/views/app/management/residents/resident-page/components/ResidentAutopaymentSubrow.vue'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import StatusAutoPaymentSetting from '@/components/statuses/StatusAutoPaymentSetting.vue'
import PaymentMethodLabel from '@/components/labels/PaymentMethodLabel.vue'
import { User } from '@/classes/User'
import Api from '@/api'
import { VPopover } from 'v-tooltip'
@Component({
  props: {
    resident: {
      type: Number
    },
    enableToggle: {
      type: Boolean,
      default: false
    },
    minHeight: {
      type: String
    },
    maxHeight: {
      type: String,
      default: '300px'
    }
  },
  components: {
    PaymentMethodLabel,
    StatusAutoPaymentSetting,
    ResidentAutopaymentSubrow,
    TableSubRow,
    Table,
    Card,
    Confirm,
    Icon,
    DateTimeLabel,
    VPopover
  }
})
export default class ResidentAutoPayments extends Vue {
  user: User = Api.getUser() as User
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  EUserPermissions: any = EUserPermissions
  EAutoPaySettingStatus: any = EAutoPaySettingStatus
  EAutoPayType: any = EAutoPayType
  AUTO_PAY_OFFSETS = {
    PREVIOUS_MONTH: 'previous',
    CURRENT_MONTH: 'current',
    NEXT_MONTH: 'next'
  }

  openedAutoPayIndex: any = -1
  openedAutoPay: any = null

  selectedAutopay: any = null

  confirmStopAutopay: boolean = false

  config: ITableConfig = {
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: calc(-1rem - 1px); right: -1.5rem;',
      class: 'rounded-bottom'
    },
    useQuery: false,
    usePagination: true,
    useSubrow: true,
    fetchFunction: this.fetchAutopayItems,
    rowClick: this.openSubrow,
    maxHeight: this.$props.maxHeight,
    minHeight: this.$props.minHeight,
    columns: [
      {
        minWidth: '150px',
        width: 13,
        key: 'schedule',
        searchKey: 'schedule',
        label: 'Schedule',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '150px',
        width: 13,
        key: 'paymentType',
        searchKey: 'paymentType',
        label: 'Autopay Type',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.multiselect,
        options: this.scheduleOptionList
      },
      {
        minWidth: '140px',
        width: 12,
        key: 'next-date',
        searchKey: 'nextDate',
        label: 'Next Payment Date',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.dateRange
      },
      {
        headClass: 'bt-justify-content-end',
        class: 'text-right',
        minWidth: '120px',
        width: 9,
        key: 'next-amount',
        searchKey: 'nextAmount',
        label: 'Next Payment Amount',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.numberRange
      },
      {
        minWidth: '100px',
        width: 12,
        key: 'payment-method',
        searchKey: 'paymentMethod',
        label: 'Payment Method',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        class: 'text-right',
        headClass: 'bt-justify-content-end',
        minWidth: '80px',
        width: 12,
        key: 'amount',
        searchKey: 'amount',
        label: 'Amount',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.numberRange
      },
      {
        minWidth: '120px',
        width: 12,
        key: 'status',
        label: 'Status',
        searchKey: 'status',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.multiselect,
        options: this.autoPayStatuses
      },
      {
        minWidth: '100px',
        width: 12,
        key: 'created',
        searchKey: 'createdAt',
        label: 'Date Created',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.dateRange
      },
      // {
      //   minWidth: '100px',
      //   width: 10,
      //   key: 'updated',
      //   searchKey: 'updatedAt',
      //   label: 'Date Updated',
      //   hasSort: true,
      //   hasSearch: true,
      //   type: ETableColumnType.dateRange
      // },
      {
        class: 'text-right',
        minWidth: '50px',
        width: 5,
        key: 'actions',
        hasSort: true
      }
    ]
  }

  get residentId () {
    return this.$props.resident
  }

  get autoPaySettings () {
    return this.$store.state.payments.autoPaySettings
  }

  get autoPaySettingsTotal () {
    return this.$store.state.payments.autoPaySettingsTotal
  }

  get autoPayItems () {
    return this.$store.state.payments.autoPayItems
  }

  mounted () {
    this.$watch('resident', () => {
      // @ts-ignore
      this.$refs.table.initSearch()
    })
  }

  fetchAutopayItems (filters: IResidentAutoPaySettingFilters) {
    this.paymentsModuleInstance.fetchResidentAutoPaySettings({ resident: this.residentId, filters })
  }

  openSubrow (row: any, index: number) {
    if (index === this.openedAutoPayIndex) {
      this.openedAutoPayIndex = -1
      return
    }
    this.openedAutoPayIndex = index
    this.openedAutoPay = row
  }

  getDayLabel (dayOfMonth: number) {
    const getFirstThreeOrdinals = function (num: string) {
      switch (num) {
        case '1':
          return 'st'
        case '2':
          return 'nd'
        case '3':
          return 'rd'
      }
    }
    if (dayOfMonth <= 0 && dayOfMonth > 31) {
      return 'N/A'
    }

    let label = dayOfMonth.toString()

    if (dayOfMonth >= 1 && dayOfMonth <= 3) {
      label += getFirstThreeOrdinals(dayOfMonth.toString())
    } else if ((dayOfMonth >= 21 && dayOfMonth <= 23) || dayOfMonth === 31) {
      let split_num = label.split('')
      label += getFirstThreeOrdinals(split_num[1])
    } else {
      label += 'th'
    }

    if (dayOfMonth >= 28) {
      label += ' or last day of month'
    }
    return label
  }

  confirmStop (obj: any) {
    this.selectedAutopay = obj
    this.confirmStopAutopay = true
  }

  cancelConfirmStop () {
    this.selectedAutopay = null
    this.confirmStopAutopay = false
  }

  async autoPayStop () {
    this.confirmStopAutopay = false
    await this.paymentsModuleInstance.autoPayDelete(this.selectedAutopay.id)
    this.$eventBus.$emit('notify', {
      color: 'var(--status-success-color)',
      message: 'was stopped',
      header: 'Autopay payment',
      icon: 'check'
    })
    this.selectedAutopay = null
    await this.paymentsModuleInstance.fetchResidentAutoPaySettings({ resident: this.residentId })
  }

  goTo (options: any) {
    this.$locationManager.rememberAndGoTo(options)
  }

  get autoPayStatuses () {
    return [
      {
        value: EAutoPaySettingStatus.ACTIVE,
        key: EAutoPaySettingStatus.ACTIVE,
        content: 'Active'
      },
      {
        value: EAutoPaySettingStatus.DELETED,
        key: EAutoPaySettingStatus.DELETED,
        content: 'Deleted'
      },
      {
        value: EAutoPaySettingStatus.COMPLETE,
        key: EAutoPaySettingStatus.COMPLETE,
        content: 'Complete'
      }
    ]
  }

  get scheduleOptionList () {
    return [{
      key: EAutoPayType.BILL_FULL_DUE,
      value: EAutoPayType.BILL_FULL_DUE,
      content: this.getAutoPayTypeLabel(EAutoPayType.BILL_FULL_DUE)
    }, {
      key: EAutoPayType.BILL_ANYWAY,
      value: EAutoPayType.BILL_ANYWAY,
      content: this.getAutoPayTypeLabel(EAutoPayType.BILL_ANYWAY)
    }, {
      key: EAutoPayType.BILL_MAX_ONLY,
      value: EAutoPayType.BILL_MAX_ONLY,
      content: this.getAutoPayTypeLabel(EAutoPayType.BILL_MAX_ONLY)
    }, {
      key: EAutoPayType.BILL_MONTH_DUE,
      value: EAutoPayType.BILL_MONTH_DUE,
      content: this.getAutoPayTypeLabel(EAutoPayType.BILL_MONTH_DUE)
    }]
  }

  getAutoPayTypeLabel (autoPayType: string) {
    const AUTO_PAY_TYPE_LABEL: any = {
      [EAutoPayType.BILL_MAX_ONLY]: 'Up to Max Amount',
      [EAutoPayType.BILL_ANYWAY]: 'Fixed Amount',
      [EAutoPayType.BILL_MONTH_DUE]: 'Monthly balance',
      [EAutoPayType.BILL_FULL_DUE]: 'Full balance'
    }
    return AUTO_PAY_TYPE_LABEL[autoPayType]
  }
}
